import { render, staticRenderFns } from "./EmpresaRead.vue?vue&type=template&id=ab8edd2a&"
import script from "./EmpresaRead.vue?vue&type=script&lang=js&"
export * from "./EmpresaRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports